import { StatusIcon } from '../StatusIcon';
  
    export const GroupIcon = ({ status }: { status?: 'valid' | 'invalid' | 'warning' | 'notvalid' }) => {
      if (!status) return null;
    return <StatusIcon status={status || 'valid'} />;
  };